<!-- eslint-disable max-len -->
<template>
  <!-- <header class="shadow-lg bar-gradient-down sticky top-0 z-50 flex flex-row items-center h-14
    justify-between"> -->
  <div class="flex flex-col sticky top-0 z-50">
    <header class=" shadow-lg bg-neutral-800 sticky top-0 z-50 flex flex-row items-center
        h-14 justify-between font-primary">
      <div class="flex flex-row">
        <button v-if="getLoggedInUser.email" class="flex flex-row lg:hidden w-8 items-center justify-center"
          @click="showBurgerMenu = !showBurgerMenu">
          <font-awesome-icon icon="fa-solid fa-bars" size="1x" class="text-white
          cursor-pointer ml-2 text-xl" />
        </button>
        <button class="flex space-x-4 flex-row h-full items-center justify-center px-4">
          <img src="@/assets/img/aab-logo-2.png" alt="" class="h-8" />
          <p class="font-primary lg:text-xl font-extrabold text-white">Household GHG Calculator</p>
        </button>
      </div>
      <div v-if="getLoggedInUser.email" class="dropdown hidden lg:flex relative items-center bg-neutral-800
      h-full hover:bg-neutral-600 cursor-pointer  px-4 justify-center text-left">
        <p class=" text-white font-poppins
        font-light text-lg w-full text-center">
          {{ getLoggedInUser.email }}
          <font-awesome-icon icon="fa-solid fa-caret-down" size="1x" class="text-white
            cursor-pointer ml-2" />
        </p>
        <div class="dropdown-menu absolute hidden mt-28 p-4 bg-white w-full
        text-md font-primary shadow-lg hover:bg-neutral-200">
          <button @click="logout" class="text-neutral-700 ">
            <font-awesome-icon icon="fa-solid fa-right-from-bracket" size="1x" class="text-neutral-700
            cursor-pointer" /> &nbsp;
            Logout
          </button>
        </div>
      </div>
    </header>
    <div v-if="showBurgerMenu" class="flex flex-col w-full h-20 bg-white shadow-md absolute top-14">
      <h3 class="font-primary text-md text-white text-left p-2 bg-neutral-600">{{ getLoggedInUser.email }}</h3>
      <button @click="logout" class="text-neutral-700 text-left p-2">
        <font-awesome-icon icon="fa-solid fa-right-from-bracket" size="1x" class="text-neutral-700
            cursor-pointer" /> &nbsp;
        Logout
      </button>
    </div>
  </div>
</template>
<script>
// import PrimaryButton from './PrimaryButton.vue';
import { getAuth, signOut } from 'firebase/auth';
import { mapGetters } from 'vuex';

export default {
  name: 'HeaderComponent',
  components: {
    // PrimaryButton,
  },
  data() {
    return {
      showBurgerMenu: false,
    };
  },
  methods: {
    showMobileMenu() {
      console.log('HOOOOOOOO');
      this.showBurgerMenu = true;
    },
    logout() {
      this.showBurgerMenu = false;
      const auth = getAuth();
      signOut(auth)
        .then(() => {
          // Sign-out successful.
          this.$store.commit('setUser', {});
          this.$router.push('/');
        })
        .catch((error) => {
          // An error happened.
          console.log(error);
        });
    },
    // logout() {
    //   console.log('logout!');
    // },
    goToLoginPage() {
      this.$router.push('login');
    },
    openMobileMenu() {
      this.$store.commit('setMobileMenuState', { show: false });
      console.log('show mobile menu', this.getMobileMenuState);
    },
  },
  computed: {
    ...mapGetters(['getLoggedInUser', 'getMobileMenuState']),
    // fullName() {
    //   try {
    //     const name = `${this.getLoggedInUser.first_name} ${this.getLoggedI
    // nUser.middle_name[0]}. ${this.getLoggedInUser.last_name}`;
    //     return name;
    //   } catch (e) {
    //     console.log(e);
    //     return 'Master';
    //   }
    // },
  },
};
</script>
<style scoped>
.dropdown:hover .dropdown-menu {
  display: block;
}

/* .bar-gradient-down {
    background-image: linear-gradient(180deg,
        hsl(242deg 47% 34%) 0%,
        hsl(244deg 49% 35%) 21%,
        hsl(247deg 51% 35%) 30%,
        hsl(249deg 53% 35%) 39%,
        hsl(251deg 55% 35%) 46%,
        hsl(254deg 57% 35%) 54%,
        hsl(256deg 59% 35%) 61%,
        hsl(259deg 61% 35%) 69%,
        hsl(261deg 64% 35%) 79%,
        hsl(264deg 67% 35%) 100%);
  } */

.bar-gradient-down {
  background-image: linear-gradient(180deg,
      hsl(244deg 47% 20%) 0%,
      hsl(243deg 47% 22%) 21%,
      hsl(243deg 47% 23%) 30%,
      hsl(243deg 47% 25%) 39%,
      hsl(243deg 47% 26%) 46%,
      hsl(243deg 47% 28%) 54%,
      hsl(243deg 47% 29%) 61%,
      hsl(242deg 47% 31%) 69%,
      hsl(242deg 47% 33%) 79%,
      hsl(242deg 47% 34%) 100%);
}
</style>
